import React from "react";

export const DevCredit = ({ className = "" }) => (
  <div
    data-testid="dev-credit"
    className={`text-center text-[10px] font-mono uppercase tracking-[0.22em] text-[#5A5F68] px-4 leading-relaxed ${className}`}
  >
    ScanEye Labs <span className="text-[#DEFF9A]/60">|</span> Tecnología de Verificación Forense por Antonio Moya Miralles
  </div>
);
